export default {
  SET_REPORT_TYPE: (state, data) => {
    state.report_type = data;
  },
};
